<template>
  <div class="home">
    This is requests index view
    <router-view></router-view>
  </div>
</template>

<script>

export default {
    name: 'requests'
};
</script>
